import validators from '../../utils/validators';

class QuestionnaireField {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      label: (v) => validators.isNotEmptyString(v),
      note: (v) => validators.isNotEmptyStringOrNull(v),
      type: (v) => validators.isNotEmptyString(v),
      sort: (v) => validators.isNumber(v),
      level: (v) => validators.isNumberOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid QuestionnaireField property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }
  }
}

export default QuestionnaireField;
